import {
    minLength,
    required,
    email,
    requiredIf
} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import { siteService } from "../../../services/SiteService";

export default {
    name: "Contact",

    components: { Multiselect },

    props: {
        listOfInsurance: {
            type: Array,
            default: null
        }
    },

    data: () => {
        return {
            dismissSecs: 5,
            dismissCountDown: 0,
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
            insurance: null
        };
    },

    validations: {
        name: {
            required,
            minLength: minLength(2)
        },
        email: {
            required,
            email,
            minLength: minLength(4)
        },
        phone: {
            required,
            minLength: minLength(10)
        },
        subject: {
            required: requiredIf(function() {
                return !this.listOfInsurance;
            }),
            minLength: minLength(2)
        },
        message: {
            required,
            minLength: minLength(10)
        },
        insurance: {
            required: requiredIf(function() {
                return this.listOfInsurance;
            })
        }
    },

    computed: {
        nameIsRequired: function() {
            return this.$v.name.$anyDirty && this.$v.name.$invalid;
        },

        emailIsRequired: function() {
            return this.$v.email.$anyDirty && !this.$v.email.required;
        },

        emailIsInvalid: function() {
            return this.$v.email.$model.length > 0 && !this.$v.email.email;
        },

        phoneIsRequired: function() {
            return this.$v.phone.$anyDirty && this.$v.phone.$invalid;
        },

        subjectIsRequired: function() {
            return this.$v.subject.$anyDirty && this.$v.subject.$invalid;
        },

        messageIsRequired: function() {
            return this.$v.message.$anyDirty && this.$v.message.$invalid;
        },
        insuranceIsRequired: function() {
            return this.$v.insurance.$anyDirty && this.$v.insurance.$invalid;
        }
    },

    methods: {
        onSubmit: function() {
            if (!this.$v.$invalid) {
                siteService
                    .postMessage(this.generatePayload())
                    .then(() => {

                        this.showAlert();
                        //this.$bvToast.toast("Mesajul a fost trimis cu succes!", {
                        //    title: "Mesaj trimis.",
                        //    variant: "success",
                        //    autoHideDelay: 7000
                        //});
                        this.clearForm();
                    })
                    .catch(err => {
                        console.log(err);
                        this.$bvToast.toast(
                            "A aparut o eroare. Te rugam incearca din nou.",
                            {
                                title: "Eroare",
                                variant: "danger",
                                autoHideDelay: 7000
                            }
                        );
                    });
            } else {
                this.$v.$touch();
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs;
        },
        generatePayload: function() {
            return {
                Name: this.name,
                Subject: this.listOfInsurance
                    ? "Mesaj din pagina de lista completa"
                    : this.subject,
                Email: this.email,
                Phone: this.phone,
                Message: this.message,
                OrderTypeCode: this.listOfInsurance ? this.insurance : null
            };
        },
        clearForm: function() {
            this.$refs.form.reset();
            this.$v.$reset();
            this.phone = "";
            this.name = "";
            this.email = "";
            this.message = "";
            this.subject = "";
            this.insurance = "";
        }
    },

    mounted() {}
};
